import { useLayoutEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { saveReferralCode } from '@/lib/referral-tracking'

export function ReferralTracking() {
	const location = useLocation()
	const navigate = useNavigate()

	useLayoutEffect(() => {
		const params = new URLSearchParams(location.search)
		if (!params.has('code')) {
			return
		}

		const code = params.get('code')
		if (code) {
			saveReferralCode(code)
		}

		params.delete('code')
		const search = params.toString()
		navigate(
			{
				pathname: location.pathname,
				search: search ? `?${search}` : '',
				hash: location.hash,
			},
			{
				replace: true,
				state: location.state,
			},
		)
	}, [location.hash, location.pathname, location.search, location.state, navigate])

	return null
}
